// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.event-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.5s ease-in-out;
  overflow-y: auto; 
}

.event-modal-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: var(--clr-white);
  padding: 2rem;
  border-radius: var(--borderRadius);
  box-shadow: var(--shadow-3);
  width: 60rem;
  max-width: 100%;
  /* max-height: 95vh; */
  overflow-y: auto;
  animation: slideIn 0.4s ease;
  gap: 1.5rem; 
}

/* Appointment Section Styling */
.appointment-section {
  width: 100%;
  background-color: var(--grey-300); 
  padding: 1rem;
  border-radius: 10px; 
  border: 1px solid var(--clr-primary-5); 
  box-shadow: var(--shadow-2); 
}

/* Intake Form Section Styling */
.intake-form-section {
  /* background-color: var(--grey-200);  */
  padding: 1.5rem;
  border-radius: 10px; 
  border: 1px solid var(--clr-primary-5); 
  box-shadow: var(--shadow-2); 
}

.intake-form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.download-icon-button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.5rem;
  color: var(--clr-primary-3); 
  transition: transform 0.2s ease, color 0.2s ease;
}

.download-icon-button:hover {
  background: none;
  color: var(--clr-primary-1); 
  transform: scale(1.1); 
}


.appointment-section, .intake-form-section {
  /* width: 48%;  */
  padding: 1rem;
  display: flex;
  flex-direction: column;
}



.event-modal-footer {
  background-color: var(--clr-white);
  padding: 1rem;
  box-shadow: var(--shadow-2);
  display: flex;
  justify-content: flex-end;
}

.appointment-section h3, .intake-form-section h4 {
  margin-top: 0;
  margin-bottom: 1rem;
  color: var(--clr-primary-5);
  font-size: 1.5rem; 
  text-align: left;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 1rem;
  color: var(--clr-grey-5);
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 0.8rem;
  border: 1px solid var(--grey-400);
  border-radius: var(--borderRadius);
  background-color: var(--grey-100);
  font-size: 1rem;
  color: var(--clr-grey-3);
  transition: var(--transition);
}

.form-group textarea {
  resize: vertical;
  min-height: 4rem;
}

.form-group input:focus,
.form-group textarea:focus {
  border-color: var(--clr-primary-5); 
  background-color: var(--grey-50);
  outline: none;
}

.modal-actions {
  display: flex;
  justify-content: flex-end; 
  gap: 1rem;
  margin-top: 1rem;
}

.modal-actions .event-modal-btn {
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: var(--borderRadius);
  background-color: var(--clr-primary-5);
  color: var(--clr-white);
  cursor: pointer;
  font-size: 1rem;
  transition: var(--transition);
}

.modal-actions .event-modal-btn:hover {
  background-color: var(--clr-primary-3);
}

.confirmation-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--clr-grey-1);
  padding: 1.5rem;
  border-radius: var(--borderRadius);
  box-shadow: var(--shadow-2);
  z-index: 1001;
  text-align: center;
  max-width: 20rem;
  width: 80%;
}

.confirmation-modal p {
  margin-bottom: 1rem;
  color: var(--clr-grey-5);
}

.confirmation-modal .modal-actions {
  display: flex;
  justify-content: space-around;
}

@media (max-width: 768px) {
  .event-modal-content {
    flex-direction: column; 
    width: 90%; 
    max-height: 90vh;
    overflow-y: auto;
  }

  .appointment-section, .intake-form-section {
    width: 100%; 
  }

  .modal-actions {
    flex-direction: column; 
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
  }

  .modal-actions .event-modal-btn {
    width: 100%; 
  }
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateY(-1.25rem);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Fix for the buttons layout */
.custom-modal-actions {
  display: flex;
  justify-content: flex-end; 
  gap: 1rem;
  margin-top: 1.5rem;
  flex-wrap: wrap; 
  width: 100%; 
}

.event-modal-btn  {
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  border: none;
  font-size: small;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
}

.event-modal-btn :hover {
  transform: scale(1.05);
}

.event-modal-btn.custom-save-btn,
.event-modal-btn.custom-complete-btn,
.event-modal-btn.custom-delete-btn {
  background-color: var(--clr-primary-6);
  color: var(--clr-white);
}

.event-modal-btn.custom-save-btn:hover,
.event-modal-btn.custom-complete-btn:hover,
.event-modal-btn.custom-delete-btn:hover {
  background-color: var(--clr-primary-4);
}

.event-modal-btn.custom-pay-btn {
  background-color: var(--clr-primary-3);
  color: var(--clr-white);
}

.event-modal-btn.custom-pay-btn:hover {
  background-color: var(--clr-primary-1);
}


.event-modal-btn.custom-save-btn:disabled {
  cursor: not-allowed; 
  opacity: 0.6;
}


.event-modal-btn.custom-close-btn {
  background-color: var(--clr-grey-6);
  color: var(--clr-white);
}

.event-modal-btn.custom-close-btn:hover {
  background-color: var(--clr-grey-5);
}

/* Fixing responsiveness */
@media (max-width: 768px) {
  .custom-modal-actions {
    flex-direction: column; 
    align-items: flex-start; 
    width: 100%; 
  }

  .event-modal-btn {
    width: 100%; 
  }
}


.event-modal-content.single-column {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 650px; 
  padding: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Scheduling/styles/EventModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;EAClC,aAAa;EACb,kCAAkC;EAClC,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE,wCAAwC;EACxC,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;AACvB;;;AAGA;EACE,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;;;AAIA;EACE,kCAAkC;EAClC,aAAa;EACb,2BAA2B;EAC3B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,iCAAiC;EACjC,kCAAkC;EAClC,iCAAiC;EACjC,eAAe;EACf,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,kCAAkC;EAClC,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kCAAkC;EAClC,sCAAsC;EACtC,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,mCAAmC;EACnC,eAAe;EACf,kCAAkC;EAClC,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;;;EAGE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;;AAGA;EACE,mBAAmB;EACnB,YAAY;AACd;;;AAGA;EACE,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,0BAA0B;AAC1B;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf","sourcesContent":[".event-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  animation: fadeIn 0.5s ease-in-out;\n  overflow-y: auto; \n}\n\n.event-modal-content {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  background-color: var(--clr-white);\n  padding: 2rem;\n  border-radius: var(--borderRadius);\n  box-shadow: var(--shadow-3);\n  width: 60rem;\n  max-width: 100%;\n  /* max-height: 95vh; */\n  overflow-y: auto;\n  animation: slideIn 0.4s ease;\n  gap: 1.5rem; \n}\n\n/* Appointment Section Styling */\n.appointment-section {\n  width: 100%;\n  background-color: var(--grey-300); \n  padding: 1rem;\n  border-radius: 10px; \n  border: 1px solid var(--clr-primary-5); \n  box-shadow: var(--shadow-2); \n}\n\n/* Intake Form Section Styling */\n.intake-form-section {\n  /* background-color: var(--grey-200);  */\n  padding: 1.5rem;\n  border-radius: 10px; \n  border: 1px solid var(--clr-primary-5); \n  box-shadow: var(--shadow-2); \n}\n\n.intake-form-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.download-icon-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1.5rem;\n  color: var(--clr-primary-3); \n  transition: transform 0.2s ease, color 0.2s ease;\n}\n\n.download-icon-button:hover {\n  background: none;\n  color: var(--clr-primary-1); \n  transform: scale(1.1); \n}\n\n\n.appointment-section, .intake-form-section {\n  /* width: 48%;  */\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n}\n\n\n\n.event-modal-footer {\n  background-color: var(--clr-white);\n  padding: 1rem;\n  box-shadow: var(--shadow-2);\n  display: flex;\n  justify-content: flex-end;\n}\n\n.appointment-section h3, .intake-form-section h4 {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  color: var(--clr-primary-5);\n  font-size: 1.5rem; \n  text-align: left;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-size: 1rem;\n  color: var(--clr-grey-5);\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 0.8rem;\n  border: 1px solid var(--grey-400);\n  border-radius: var(--borderRadius);\n  background-color: var(--grey-100);\n  font-size: 1rem;\n  color: var(--clr-grey-3);\n  transition: var(--transition);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 4rem;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  border-color: var(--clr-primary-5); \n  background-color: var(--grey-50);\n  outline: none;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end; \n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.modal-actions .event-modal-btn {\n  padding: 0.8rem 1.5rem;\n  border: none;\n  border-radius: var(--borderRadius);\n  background-color: var(--clr-primary-5);\n  color: var(--clr-white);\n  cursor: pointer;\n  font-size: 1rem;\n  transition: var(--transition);\n}\n\n.modal-actions .event-modal-btn:hover {\n  background-color: var(--clr-primary-3);\n}\n\n.confirmation-modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: var(--clr-grey-1);\n  padding: 1.5rem;\n  border-radius: var(--borderRadius);\n  box-shadow: var(--shadow-2);\n  z-index: 1001;\n  text-align: center;\n  max-width: 20rem;\n  width: 80%;\n}\n\n.confirmation-modal p {\n  margin-bottom: 1rem;\n  color: var(--clr-grey-5);\n}\n\n.confirmation-modal .modal-actions {\n  display: flex;\n  justify-content: space-around;\n}\n\n@media (max-width: 768px) {\n  .event-modal-content {\n    flex-direction: column; \n    width: 90%; \n    max-height: 90vh;\n    overflow-y: auto;\n  }\n\n  .appointment-section, .intake-form-section {\n    width: 100%; \n  }\n\n  .modal-actions {\n    flex-direction: column; \n    gap: 0.5rem;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .modal-actions .event-modal-btn {\n    width: 100%; \n  }\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(-1.25rem);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* Fix for the buttons layout */\n.custom-modal-actions {\n  display: flex;\n  justify-content: flex-end; \n  gap: 1rem;\n  margin-top: 1.5rem;\n  flex-wrap: wrap; \n  width: 100%; \n}\n\n.event-modal-btn  {\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  border: none;\n  font-size: small;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s, transform 0.2s;\n}\n\n.event-modal-btn :hover {\n  transform: scale(1.05);\n}\n\n.event-modal-btn.custom-save-btn,\n.event-modal-btn.custom-complete-btn,\n.event-modal-btn.custom-delete-btn {\n  background-color: var(--clr-primary-6);\n  color: var(--clr-white);\n}\n\n.event-modal-btn.custom-save-btn:hover,\n.event-modal-btn.custom-complete-btn:hover,\n.event-modal-btn.custom-delete-btn:hover {\n  background-color: var(--clr-primary-4);\n}\n\n.event-modal-btn.custom-pay-btn {\n  background-color: var(--clr-primary-3);\n  color: var(--clr-white);\n}\n\n.event-modal-btn.custom-pay-btn:hover {\n  background-color: var(--clr-primary-1);\n}\n\n\n.event-modal-btn.custom-save-btn:disabled {\n  cursor: not-allowed; \n  opacity: 0.6;\n}\n\n\n.event-modal-btn.custom-close-btn {\n  background-color: var(--clr-grey-6);\n  color: var(--clr-white);\n}\n\n.event-modal-btn.custom-close-btn:hover {\n  background-color: var(--clr-grey-5);\n}\n\n/* Fixing responsiveness */\n@media (max-width: 768px) {\n  .custom-modal-actions {\n    flex-direction: column; \n    align-items: flex-start; \n    width: 100%; \n  }\n\n  .event-modal-btn {\n    width: 100%; \n  }\n}\n\n\n.event-modal-content.single-column {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 650px; \n  padding: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
